import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useState,
} from "react";
import { BookingsBudgetContextProps } from "./bookings-budget-types";

const BookingsBudgetContext = createContext<BookingsBudgetContextProps>(
  {} as BookingsBudgetContextProps,
);

export const BookingsBudgetProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [budgetValue, setBudgetValue] = useState(0);

  return (
    <BookingsBudgetContext.Provider value={{ budgetValue, setBudgetValue }}>
      {children}
    </BookingsBudgetContext.Provider>
  );
};

export const useBookingsBudgetValue = () => useContext(BookingsBudgetContext);
